import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { usePageTracking } from "./hooks/use-page-tracking";
import Index from "./pages/Index";
import Designer from "./pages/Designer";
import Login from "./pages/Login";
import BecomeSeller from "./pages/BecomeSeller";
import Gallery from "./pages/Gallery";
import AboutKente from "./pages/AboutKente";
import ContactUs from "./pages/ContactUs";
import HelpCenter from "./pages/HelpCenter";
import ShippingInfo from "./pages/ShippingInfo";
import Returns from "./pages/Returns";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import NotFound from "./pages/NotFound";
import CustomerStore from "./components/Store/CustomerStore";
import StorePreviewPage from "./pages/StorePreviewPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import WeaverDashboard from "./pages/WeaverDashboard";

const queryClient = new QueryClient();

// Component to handle page tracking
const AppRoutes = () => {
  usePageTracking(); // Track all page visits

  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/designer" element={<Designer />} />
      <Route path="/login" element={<Login />} />
      <Route path="/seller/dashboard" element={<Login />} />
      <Route path="/become-seller" element={<BecomeSeller />} />

      {/* Navigation Pages */}
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/about" element={<AboutKente />} />
      <Route path="/contact" element={<ContactUs />} />

      {/* Support Pages */}
      <Route path="/help" element={<HelpCenter />} />
      <Route path="/shipping" element={<ShippingInfo />} />
      <Route path="/returns" element={<Returns />} />
      <Route path="/faq" element={<FAQ />} />

      {/* Legal Pages */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/cookies" element={<CookiePolicy />} />

      {/* Store Routes */}
      <Route
        path="/store/:storeSlug"
        element={
          <CustomerStore
            storeData={{
              name: "Sample Kente Store",
              description: "Authentic Kente designs crafted with love",
              logo: "",
              primaryColor: "#8B4513",
              secondaryColor: "#DAA520",
              accentColor: "#FFD700",
              items: [],
              isPublished: true,
              storeUrl: "",
            }}
            storeSlug="sample-store"
          />
        }
      />

      {/* Store Preview with URL Parameters */}
      <Route path="/preview" element={<StorePreviewPage />} />

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />

      {/* Weaver/Seller Routes */}
      <Route path="/weaver/dashboard" element={<WeaverDashboard />} />

      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <AppRoutes />
        </TooltipProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
